import ContentLoader from 'react-content-loader';

import { sendClick } from 'reaxl-analytics';

import { getSrpPathFromSessionStorage } from '@/utilities/srpPathFromSessionStorageUtils';

import BackLink from '@/components/BackLink';
import SearchLink from '@/components/SearchLink';

/**
 * BackToResultsSessionLink component that renders a navigation link back to the user's
 * previous search results page (SRP). The link text and destination are dynamically
 * determined based on the SRP path stored in session storage.
 *
 * This component automatically:
 * - Retrieves the last visited SRP path from session storage
 * - Displays contextual link text based on the SRP type
 * - Preserves the user's search state when navigating back
 *
 * The component works in conjunction with the useLastSrpUrl hook to provide
 * scroll position restoration when the user returns to their search results.
 *
 * @returns {JSX.Element} A Next.js Link component that navigates back to the stored SRP
 */
export default function BackToResultsLink() {
    const href = getSrpPathFromSessionStorage();

    const handleBackToResultsLinkClick = (event) => {
        sendClick('backToResultsLinkClick', event);
    };

    if (!href) return <SearchLink />;
    return (
        <BackLink
            data-cmp="backToResultsLink"
            href={href}
            onClick={handleBackToResultsLinkClick}
        >
            Back to results
        </BackLink>
    );
}

export function BackToResultsLinkPlaceholder() {
    return (
        <ContentLoader
            speed={2}
            height={64}
            backgroundColor="#e1e4e8"
            foregroundColor="#f8f8f8"
            data-cmp="backToResultsLinkPlaceholder"
        >
            <rect
                x={0}
                y={20}
                width={144}
                height={24}
            />
        </ContentLoader>
    );
}
